(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bastion-about-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.baReady === 'true') return;
    root.dataset.baReady = 'true';

    root.querySelectorAll('[data-tab-group]').forEach(group => {
      const tabs = [...group.querySelectorAll('[role="tab"]')];
      const select = tab => {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = root.querySelector('#' + item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(tabs[next]);
          tabs[next].focus();
        });
      });
    });

    const dialog = root.querySelector('.film-dialog');
    const video = dialog?.querySelector('video');
    if (dialog && video) {
      let opener;
      root.querySelectorAll('[data-open-film]').forEach(button => button.addEventListener('click', () => {
        opener = button;
        dialog.showModal();
        video.currentTime = 0;
        video.play().catch(() => {});
      }));
      dialog.querySelector('.close-film')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { video.pause(); opener?.focus({preventScroll:true}); });
      const showVideoError = () => { const message = dialog.querySelector('.video-error'); if (message) message.hidden = false; };
      video.addEventListener('error', showVideoError);
      video.querySelector('source')?.addEventListener('error', showVideoError);
    }

    const chapterLinks = [...root.querySelectorAll('.chapter-nav a[href^="#"]')];
    if ('IntersectionObserver' in window && chapterLinks.length) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          chapterLinks.forEach(link => {
            if (link.hash === '#' + entry.target.id) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        });
      }, {rootMargin:'-10% 0px -65% 0px'});
      chapterLinks.forEach(link => {
        const section = root.querySelector(link.hash);
        if (section) observer.observe(section);
      });
    }

    const carousel = root.querySelector('[data-review-carousel]');
    if (!carousel) return;
    const slides = [...carousel.querySelectorAll('.review-slide')];
    const dots = [...carousel.querySelectorAll('[data-review-index]')];
    const stage = carousel.querySelector('.review-slides');
    const count = carousel.querySelector('.review-count');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let timer;
    let visible = false;
    let hovering = false;
    let focused = false;
    const select = index => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.hidden = !active;
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
        dots[i]?.setAttribute('aria-current', String(active));
      });
      count.textContent = String(current + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
    };
    const updateTimer = () => {
      window.clearInterval(timer);
      const rotate = visible && !hovering && !focused && !document.hidden && !reducedMotion.matches;
      stage.setAttribute('aria-live', rotate ? 'off' : 'polite');
      if (rotate) timer = window.setInterval(() => select(current + 1), 6500);
    };
    const navigate = index => { select(index); updateTimer(); };
    carousel.querySelector('[data-review-prev]')?.addEventListener('click', () => navigate(current - 1));
    carousel.querySelector('[data-review-next]')?.addEventListener('click', () => navigate(current + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => navigate(i)));
    carousel.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      navigate(current + (event.key === 'ArrowRight' ? 1 : -1));
    });
    carousel.addEventListener('mouseenter', () => { hovering = true; updateTimer(); });
    carousel.addEventListener('mouseleave', () => { hovering = false; updateTimer(); });
    carousel.addEventListener('focusin', () => { focused = true; updateTimer(); });
    carousel.addEventListener('focusout', event => { focused = carousel.contains(event.relatedTarget); updateTimer(); });
    document.addEventListener('visibilitychange', updateTimer);
    reducedMotion.addEventListener('change', updateTimer);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        updateTimer();
      }, {threshold:.2}).observe(carousel);
    }
    let touchStart;
    stage.addEventListener('touchstart', event => {
      touchStart = {x:event.changedTouches[0].clientX, y:event.changedTouches[0].clientY};
    }, {passive:true});
    stage.addEventListener('touchend', event => {
      if (!touchStart) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) navigate(current + (dx < 0 ? 1 : -1));
      touchStart = null;
    }, {passive:true});
    select(0);
  };
  document.querySelectorAll('.ba-reference').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.ba-reference').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bastion-custom-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bastion-custom-banner')) {
    customElements.define('bastion-custom-banner', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.status = this.querySelector('[data-status]');
        this.pauseButton = this.querySelector('[data-pause]');
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.hasAttribute('data-active')));
        this.requestedIndex = this.index;
        this.transitionRequest = 0;
        this.slideLoads = new Map();
        this.hasRotated = false;
        this.paused = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.mobileViewport = window.matchMedia('(max-width: 699px)');
        this.onPrevious = () => this.show((this.requestedIndex ?? this.index) - 1, true);
        this.onNext = () => this.show((this.requestedIndex ?? this.index) + 1, true);
        this.onPause = () => this.setPaused(!this.paused);
        this.onMouseEnter = () => this.stopTimer();
        this.onMouseLeave = () => this.startTimer();
        this.onVisibilityChange = () => document.hidden ? this.stopTimer() : this.startTimer();
        this.onBlockSelect = (event) => {
          const slideIndex = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (slideIndex >= 0) {
            this.setPaused(true);
            this.show(slideIndex, false);
          }
        };

        this.querySelector('[data-previous]')?.addEventListener('click', this.onPrevious);
        this.querySelector('[data-next]')?.addEventListener('click', this.onNext);
        this.pauseButton?.addEventListener('click', this.onPause);
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true)));
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        if (this.dataset.pauseOnHover === 'true') {
          this.addEventListener('mouseenter', this.onMouseEnter);
          this.addEventListener('mouseleave', this.onMouseLeave);
        }

        this.show(this.index, false);
      }

      disconnectedCallback() {
        this.stopTimer();
        this.querySelector('[data-previous]')?.removeEventListener('click', this.onPrevious);
        this.querySelector('[data-next]')?.removeEventListener('click', this.onNext);
        this.pauseButton?.removeEventListener('click', this.onPause);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.removeEventListener('mouseenter', this.onMouseEnter);
        this.removeEventListener('mouseleave', this.onMouseLeave);
      }

      async loadSlide(index) {
        const slide = this.slides[index];
        const picture = slide?.querySelector('[data-deferred-image]');
        if (!picture) return;
        if (this.slideLoads.has(index)) return this.slideLoads.get(index);

        const image = picture.querySelector('img');
        if (!image) return;

        const loadPromise = new Promise((resolve) => {
          let settled = false;
          const finish = () => {
            if (settled) return;
            settled = true;
            if (typeof image.decode === 'function' && image.naturalWidth > 0) {
              image.decode().catch(() => {}).finally(resolve);
            } else {
              resolve();
            }
          };

          image.addEventListener('load', finish, { once: true });
          image.addEventListener('error', resolve, { once: true });

          picture.querySelectorAll('source[data-srcset]').forEach((source) => {
            source.setAttribute('srcset', source.dataset.srcset);
            source.removeAttribute('data-srcset');
          });

          image.loading = 'eager';
          if (image.dataset.srcset) {
            image.srcset = image.dataset.srcset;
            image.removeAttribute('data-srcset');
          }
          if (image.dataset.src) {
            image.src = image.dataset.src;
            image.removeAttribute('data-src');
          }

          picture.removeAttribute('data-deferred-image');
          if (image.complete) finish();
        });

        this.slideLoads.set(index, loadPromise);
        return loadPromise;
      }

      async show(requestedIndex, announce) {
        if (this.slides.length === 0) return;
        const targetIndex = (requestedIndex + this.slides.length) % this.slides.length;
        const previousIndex = this.index;
        const transitionRequest = ++this.transitionRequest;
        this.requestedIndex = targetIndex;
        this.stopTimer();

        await this.loadSlide(targetIndex);
        if (transitionRequest !== this.transitionRequest) return;

        this.index = targetIndex;
        this.requestedIndex = null;
        if (this.index !== previousIndex) this.hasRotated = true;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.toggleAttribute('data-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));

        if (announce && this.status) this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
        this.startTimer();
      }

      setPaused(paused) {
        this.paused = paused;
        if (this.pauseButton) {
          this.pauseButton.setAttribute('aria-pressed', String(paused));
          this.pauseButton.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        }
        paused ? this.stopTimer() : this.startTimer();
      }

      startTimer() {
        this.stopTimer();
        if (!this.hasAttribute('data-autoplay') || this.paused || this.reduceMotion || this.slides.length < 2 || document.hidden) return;
        const configuredDelay = Number(this.dataset.delay) || 6000;
        const delay = this.mobileViewport.matches && !this.hasRotated ? Math.max(configuredDelay, 9000) : configuredDelay;
        const nextIndex = (this.index + 1) % this.slides.length;
        this.preloadTimer = window.setTimeout(() => this.loadSlide(nextIndex), Math.max(0, delay - 1500));
        this.timer = window.setTimeout(() => this.show(nextIndex, false), delay);
      }

      stopTimer() {
        window.clearTimeout(this.timer);
        window.clearTimeout(this.preloadTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bastion-editorial-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bastion-editorial-card')) {
    customElements.define('bastion-editorial-card', class BastionEditorialCard extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.handleVariantChange);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.handleVariantChange);
      }

      handleVariantChange = (event) => {
        const control = event.target.closest('[data-variant-id]');

        if (!control) {
          return;
        }

        const dataNode = this.querySelector('[data-variant-prices]');
        const priceNode = this.querySelector('[data-current-price]');
        const compareNode = this.querySelector('[data-compare-price]');
        const variantInput = this.querySelector('[data-product-form-variant]');
        const addToCartButton = this.querySelector('[data-add-to-cart]');

        if (!dataNode) {
          return;
        }

        let variants = [];

        try {
          variants = JSON.parse(dataNode.textContent);
        } catch (error) {
          return;
        }

        const selectedVariant = variants.find((variant) => String(variant.id) === control.dataset.variantId);

        if (!selectedVariant) {
          return;
        }

        if (priceNode && compareNode) {
          priceNode.textContent = selectedVariant.price;
          compareNode.textContent = selectedVariant.compareAtPrice || '';
          compareNode.hidden = !selectedVariant.compareAtPrice;
        }

        if (variantInput) {
          variantInput.value = selectedVariant.id;
        }

        if (addToCartButton) {
          addToCartButton.disabled = !selectedVariant.available;
          addToCartButton.textContent = selectedVariant.available ? addToCartButton.dataset.addLabel : addToCartButton.dataset.soldOutLabel;
        }
      };
    });
  }

  if (!customElements.get('bastion-editorial-collection')) {
    customElements.define('bastion-editorial-collection', class BastionEditorialCollection extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        const filterForm = this.querySelector('[data-filter-form]');

        this.querySelectorAll('[data-filter-details]').forEach((details) => {
          details.addEventListener('toggle', () => {
            if (!details.open) {
              return;
            }

            this.querySelectorAll('[data-filter-details]').forEach((otherDetails) => {
              if (otherDetails !== details) {
                otherDetails.open = false;
              }
            });
          }, { signal });
        });

        filterForm?.addEventListener('change', (event) => {
          const isPriceInput = event.target.closest('.price-range') !== null;

          if (filterForm.dataset.updateOnChange === 'true' && !isPriceInput) {
            filterForm.requestSubmit();
          }
        }, { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bastion-editorial-search"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bastion-editorial-card')) {
    customElements.define('bastion-editorial-card', class BastionEditorialCard extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.handleVariantChange);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.handleVariantChange);
      }

      handleVariantChange = (event) => {
        const control = event.target.closest('[data-variant-id]');

        if (!control) {
          return;
        }

        const dataNode = this.querySelector('[data-variant-prices]');
        const priceNode = this.querySelector('[data-current-price]');
        const compareNode = this.querySelector('[data-compare-price]');
        const variantInput = this.querySelector('[data-product-form-variant]');
        const addToCartButton = this.querySelector('[data-add-to-cart]');

        if (!dataNode) {
          return;
        }

        let variants = [];

        try {
          variants = JSON.parse(dataNode.textContent);
        } catch (error) {
          return;
        }

        const selectedVariant = variants.find((variant) => String(variant.id) === control.dataset.variantId);

        if (!selectedVariant) {
          return;
        }

        if (priceNode && compareNode) {
          priceNode.textContent = selectedVariant.price;
          compareNode.textContent = selectedVariant.compareAtPrice || '';
          compareNode.hidden = !selectedVariant.compareAtPrice;
        }

        if (variantInput) {
          variantInput.value = selectedVariant.id;
        }

        if (addToCartButton) {
          addToCartButton.disabled = !selectedVariant.available;
          addToCartButton.textContent = selectedVariant.available ? addToCartButton.dataset.addLabel : addToCartButton.dataset.soldOutLabel;
        }
      };
    });
  }

  if (!customElements.get('bastion-editorial-collection')) {
    customElements.define('bastion-editorial-collection', class BastionEditorialCollection extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        const filterForm = this.querySelector('[data-filter-form]');

        this.querySelectorAll('[data-filter-details]').forEach((details) => {
          details.addEventListener('toggle', () => {
            if (!details.open) {
              return;
            }

            this.querySelectorAll('[data-filter-details]').forEach((otherDetails) => {
              if (otherDetails !== details) {
                otherDetails.open = false;
              }
            });
          }, { signal });
        });

        filterForm?.addEventListener('change', (event) => {
          const isPriceInput = event.target.closest('.price-range') !== null;

          if (filterForm.dataset.updateOnChange === 'true' && !isPriceInput) {
            filterForm.requestSubmit();
          }
        }, { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bastion-feature-hotspots"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bastion-feature-hotspots')) {
    class BastionFeatureHotspots extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.hotspots = Array.from(this.querySelectorAll('[data-hotspot]'));
        this.features = Array.from(this.querySelectorAll('[data-feature]'));
        this.syncing = false;

        this.hotspots.forEach((hotspot, index) => {
          hotspot.addEventListener('click', () => this.activate(index));
        });

        this.features.forEach((feature, index) => {
          feature.addEventListener('toggle', () => {
            if (this.syncing) return;

            if (feature.open) {
              this.activate(index);
            } else {
              this.updateMarker(index, false);
            }
          });
        });

        this.addEventListener('shopify:block:select', (event) => {
          const blockId = event.detail?.blockId;
          const index = this.features.findIndex((feature) => feature.dataset.blockId === blockId);

          if (index >= 0) this.activate(index);
        });

        const initiallyOpen = this.features.findIndex((feature) => feature.open);

        if (initiallyOpen >= 0) this.activate(initiallyOpen);
      }

      activate(index) {
        if (!this.features[index] || !this.hotspots[index]) return;

        this.syncing = true;

        this.features.forEach((feature, featureIndex) => {
          const selected = featureIndex === index;
          feature.open = selected;
          this.updateMarker(featureIndex, selected);
        });

        requestAnimationFrame(() => {
          this.syncing = false;
        });
      }

      updateMarker(index, active) {
        const hotspot = this.hotspots[index];

        if (!hotspot) return;

        hotspot.setAttribute('aria-expanded', active ? 'true' : 'false');

        if (active) {
          hotspot.dataset.active = 'true';
        } else {
          delete hotspot.dataset.active;
        }
      }
    }

    customElements.define('bastion-feature-hotspots', BastionFeatureHotspots);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bastion-landscape-collection-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bastion-landscape-slideshow')) {
    class BastionLandscapeSlideshow extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-bastion-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-action="slide"]'));
        this.pauseButton = this.querySelector('[data-action="pause"]');
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.dataset.active === 'true'));
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';
        this.cycleSpeed = Math.max(3000, Number(this.dataset.cycleSpeed) || 5000);
        this.manualPaused = false;
        this.interactionPaused = false;
        this.editorPaused = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onClick = this.handleClick.bind(this);
        this.onPointerEnter = this.handlePointerEnter.bind(this);
        this.onPointerLeave = this.handlePointerLeave.bind(this);
        this.onFocusIn = this.handleFocusIn.bind(this);
        this.onFocusOut = this.handleFocusOut.bind(this);
        this.onVisibilityChange = this.refreshTimer.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);
        this.onBlockDeselect = this.handleBlockDeselect.bind(this);

        this.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        if (this.pauseOnHover) {
          this.addEventListener('pointerenter', this.onPointerEnter);
          this.addEventListener('pointerleave', this.onPointerLeave);
          this.addEventListener('focusin', this.onFocusIn);
          this.addEventListener('focusout', this.onFocusOut);
        }

        this.showSlide(this.currentIndex);
        this.refreshTimer();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('pointerenter', this.onPointerEnter);
        this.removeEventListener('pointerleave', this.onPointerLeave);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.initialized = false;
      }

      handleClick(event) {
        const control = event.target.closest('[data-action]');
        if (!control || !this.contains(control)) return;

        const action = control.dataset.action;

        if (action === 'previous') {
          this.showSlide(this.currentIndex - 1);
          this.refreshTimer();
        } else if (action === 'next') {
          this.showSlide(this.currentIndex + 1);
          this.refreshTimer();
        } else if (action === 'slide') {
          this.showSlide(Number(control.dataset.slideIndex));
          this.refreshTimer();
        } else if (action === 'pause') {
          this.manualPaused = !this.manualPaused;
          this.updatePauseButton();
          this.refreshTimer();
        }
      }

      handlePointerEnter() {
        this.interactionPaused = true;
        this.refreshTimer();
      }

      handlePointerLeave() {
        this.interactionPaused = false;
        this.refreshTimer();
      }

      handleFocusIn() {
        this.interactionPaused = true;
        this.refreshTimer();
      }

      handleFocusOut(event) {
        if (!this.contains(event.relatedTarget)) {
          this.interactionPaused = false;
          this.refreshTimer();
        }
      }

      handleBlockSelect(event) {
        const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);

        if (index > -1) {
          this.editorPaused = true;
          this.showSlide(index);
          this.refreshTimer();
        }
      }

      handleBlockDeselect() {
        this.editorPaused = false;
        this.refreshTimer();
      }

      showSlide(index) {
        if (this.slides.length === 0) return;

        this.currentIndex = (index + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === this.currentIndex;
          slide.dataset.active = String(isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });

        this.dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', String(dotIndex === this.currentIndex));
        });
      }

      updatePauseButton() {
        if (!this.pauseButton) return;

        const label = this.manualPaused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
        const icon = this.pauseButton.querySelector('[data-pause-icon]');

        this.pauseButton.setAttribute('aria-label', label);
        this.pauseButton.setAttribute('aria-pressed', String(this.manualPaused));

        if (icon) icon.textContent = this.manualPaused ? '▶' : 'Ⅱ';
      }

      refreshTimer() {
        window.clearTimeout(this.timer);

        const shouldRun =
          this.slides.length > 1 &&
          this.autoplayEnabled &&
          !this.reduceMotion &&
          !this.manualPaused &&
          !this.interactionPaused &&
          !this.editorPaused &&
          document.visibilityState === 'visible';

        if (!shouldRun) return;

        this.timer = window.setTimeout(() => {
          this.showSlide(this.currentIndex + 1);
          this.refreshTimer();
        }, this.cycleSpeed);
      }
    }

    customElements.define('bastion-landscape-slideshow', BastionLandscapeSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bastion-product-essential"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bastion-volume-offer')) {
    customElements.define(
      'bastion-volume-offer',
      class extends HTMLElement {
        connectedCallback() {
          this.abortController?.abort();
          this.abortController = new AbortController();
          this.boundForms = new WeakSet();

          this.addEventListener('change', (event) => this.handleChange(event), {
            signal: this.abortController.signal,
          });
          this.addEventListener('click', (event) => this.handleClick(event), {
            signal: this.abortController.signal,
          });
          document.addEventListener('click', (event) => {
            if (!this.contains(event.target)) this.closeCheckoutNote();
          }, { signal: this.abortController.signal });
          document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') this.closeCheckoutNote();
          }, { signal: this.abortController.signal });

          this.formObserver?.disconnect();
          const sectionRoot = this.closest('.bastion-essential');

          if (sectionRoot) {
            this.formObserver = new MutationObserver(() => {
              const formId = this.getAttribute('form');
              const nextForm = formId ? document.getElementById(formId) : null;

              if (nextForm && nextForm !== this.form) {
                this.bindForm();
              }
            });
            this.formObserver.observe(sectionRoot, {
              childList: true,
              subtree: true,
            });
          }

          this.bindForm();
          this.querySelectorAll('[data-offer-card]').forEach((card) => {
            card.dataset.quantity = card.dataset.minimum || '1';
          });
          this.update();
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.formObserver?.disconnect();
          this.restoreNativeQuantity();
        }

        get selectedCard() {
          const selectedRadio = this.querySelector('.bastion-volume-offer__radio:checked');
          return selectedRadio?.closest('[data-offer-card]') || null;
        }

        get selectedQuantity() {
          const card = this.selectedCard;
          return Math.max(1, Number.parseInt(card?.dataset.quantity || card?.dataset.minimum || '1', 10) || 1);
        }

        get isBundle() {
          return Boolean(this.selectedCard && this.selectedCard.dataset.offer !== 'single');
        }

        bindForm() {
          const formId = this.getAttribute('form');
          const form = formId ? document.getElementById(formId) : null;

          if (!form) {
            return;
          }

          this.form = form;

          if (!this.boundForms.has(form)) {
            this.boundForms.add(form);
            form.addEventListener('variant:change', (event) => this.handleVariantChange(event), {
              signal: this.abortController.signal,
            });
          }

          this.updateNativeControls();
        }

        handleChange(event) {
          if (event.target.matches('.bastion-volume-offer__radio, [data-volume-variant]')) {
            if (event.target.matches('.bastion-volume-offer__radio')) {
              const card = event.target.closest('[data-offer-card]');
              card.dataset.quantity = card.dataset.minimum || '1';
            }

            this.update();
          }
        }

        handleClick(event) {
          const noteToggle = event.target.closest('[data-checkout-note-toggle]');
          const noteClose = event.target.closest('[data-checkout-note-close]');
          const offerButton = event.target.closest('[data-add-volume-offer]');

          if (noteToggle) {
            this.toggleCheckoutNote(noteToggle);
            return;
          }

          if (noteClose) {
            this.closeCheckoutNote();
            return;
          }

          if (offerButton) {
            this.handleOfferSubmit(offerButton);
            return;
          }

          const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');

          if (!button) {
            return;
          }

          const card = button.closest('[data-offer-card]');
          const minimum = Number.parseInt(card.dataset.minimum || '1', 10);
          const isUnlimited = card.dataset.unlimited === 'true';
          const maximum = isUnlimited ? Number.POSITIVE_INFINITY : Math.max(minimum, Number.parseInt(card.dataset.maximum || minimum, 10));
          const current = Number.parseInt(card.dataset.quantity || minimum, 10);
          const next = button.hasAttribute('data-quantity-plus') ? current + 1 : current - 1;
          card.dataset.quantity = String(Math.min(maximum, Math.max(minimum, next)));
          this.update();
        }

        toggleCheckoutNote(button) {
          const popover = this.querySelector('[data-checkout-note-popover]');
          if (!popover) return;

          const willOpen = popover.hidden;
          popover.hidden = !willOpen;
          button.setAttribute('aria-expanded', String(willOpen));
        }

        closeCheckoutNote() {
          const popover = this.querySelector('[data-checkout-note-popover]');
          const button = this.querySelector('[data-checkout-note-toggle]');
          if (popover) popover.hidden = true;
          if (button) button.setAttribute('aria-expanded', 'false');
        }

        handleVariantChange(event) {
          if (event.detail?.formId !== this.getAttribute('form') || !event.detail.variant?.id) {
            return;
          }

          const previousId = String(event.detail.previousVariant?.id || '');
          const nextId = String(event.detail.variant.id);

          this.querySelectorAll('[data-volume-variant]').forEach((select) => {
            if (!previousId || select.value === previousId) {
              const nextOption = Array.from(select.options).find((option) => option.value === nextId && !option.disabled);

              if (nextOption) {
                select.value = nextId;
              }
            }
          });

          this.dataset.currentVariantId = nextId;
          this.update();
        }

        ensureVariantRows(quantity) {
          const list = this.querySelector('.bastion-volume-offer__variant-list');
          const template = this.querySelector('[data-volume-unit-template]');

          if (!list || !template) return;

          let rowCount = list.querySelectorAll('[data-volume-unit]').length;

          while (rowCount < quantity) {
            const unitNumber = rowCount + 1;
            const fragment = template.content.cloneNode(true);
            const row = fragment.querySelector('[data-volume-unit]');
            const label = fragment.querySelector('[data-volume-unit-label]');
            const select = fragment.querySelector('[data-volume-variant]');
            const selectId = `${this.id}-variant-${unitNumber}`;

            row.dataset.volumeUnit = String(unitNumber);
            label.htmlFor = selectId;
            label.textContent = `${this.dataset.unitLabel || 'Item'} ${unitNumber}`;
            select.id = selectId;

            const currentOption = Array.from(select.options).find(
              (option) => option.value === String(this.dataset.currentVariantId || '') && !option.disabled
            );

            if (currentOption) select.value = currentOption.value;

            list.append(fragment);
            rowCount += 1;
          }
        }

        update() {
          const selectedCard = this.selectedCard;

          if (!selectedCard) {
            this.querySelectorAll('[data-offer-card]').forEach((card) => {
              card.removeAttribute('data-selected');
              const quantityControl = card.querySelector('[data-tier-quantity]');
              if (quantityControl) quantityControl.hidden = true;
            });

            const variantsPanel = this.querySelector('[data-volume-variants]');
            if (variantsPanel) variantsPanel.hidden = true;

            this.querySelectorAll('[data-volume-unit]').forEach((row) => {
              row.hidden = true;
              row.querySelector('[data-volume-variant]')?.setAttribute('disabled', '');
            });

            this.dataset.mode = 'none';
            this.updateTierMath();
            this.updateNativeControls();

            const offerButton = this.querySelector('[data-add-volume-offer]');
            if (offerButton) offerButton.hidden = true;

            const status = this.querySelector('[data-volume-status]');
            if (status && !status.hasAttribute('data-error')) status.textContent = '';
            return;
          }

          this.querySelectorAll('[data-offer-card]').forEach((card) => {
            const isSelected = card === selectedCard;
            card.toggleAttribute('data-selected', isSelected);
            const quantityControl = card.querySelector('[data-tier-quantity]');

            if (quantityControl) {
              quantityControl.hidden = !isSelected;
              const output = quantityControl.querySelector('[data-quantity-output]');

              if (output) {
                output.textContent = card.dataset.quantity || card.dataset.minimum || '1';
              }

              const minimum = Number.parseInt(card.dataset.minimum || '1', 10);
              const isUnlimited = card.dataset.unlimited === 'true';
              const maximum = isUnlimited ? Number.POSITIVE_INFINITY : Math.max(minimum, Number.parseInt(card.dataset.maximum || minimum, 10));
              const quantity = Number.parseInt(card.dataset.quantity || minimum, 10);
              const minus = quantityControl.querySelector('[data-quantity-minus]');
              const plus = quantityControl.querySelector('[data-quantity-plus]');

              if (minus) minus.disabled = quantity <= minimum;
              if (plus) plus.disabled = !isUnlimited && quantity >= maximum;
            }
          });

          const variantsPanel = this.querySelector('[data-volume-variants]');
          const selectableVariantCount = Array.from(
            this.querySelector('[data-volume-variant]')?.options || []
          ).filter((option) => !option.disabled).length;

          if (variantsPanel) {
            if (this.isBundle && variantsPanel.parentElement !== selectedCard) {
              selectedCard.append(variantsPanel);
            }
            variantsPanel.hidden = !this.isBundle || selectableVariantCount <= 1;
          }

          if (this.isBundle) {
            this.ensureVariantRows(this.selectedQuantity);
          }

          this.querySelectorAll('[data-volume-unit]').forEach((row, index) => {
            row.hidden = !this.isBundle || index >= this.selectedQuantity;
            row.querySelector('[data-volume-variant]')?.toggleAttribute('disabled', row.hidden);
          });

          this.dataset.mode = this.isBundle ? 'bundle' : 'single';
          this.updateTierMath();
          this.updateNativeControls();
          const offerButton = this.querySelector('[data-add-volume-offer]');
          if (offerButton) offerButton.hidden = !this.isBundle;
          const status = this.querySelector('[data-volume-status]');
          if (status && !status.hasAttribute('data-error')) status.textContent = '';
        }

        updateTierMath() {
          const unitSelects = Array.from(this.querySelectorAll('[data-volume-variant]'));
          const fallbackPrice = Number.parseInt(
            unitSelects[0]?.selectedOptions[0]?.dataset.price || unitSelects[0]?.options[0]?.dataset.price || '0',
            10
          );

          this.querySelectorAll('[data-offer-card]').forEach((card) => {
            const quantity = card.hasAttribute('data-selected')
              ? Math.max(1, Number.parseInt(card.dataset.quantity || card.dataset.minimum || '1', 10))
              : Math.max(1, Number.parseInt(card.dataset.minimum || '1', 10));
            const discount = Math.min(100, Math.max(0, Number.parseFloat(card.dataset.discount || '0')));
            let originalTotal = 0;

            for (let index = 0; index < quantity; index += 1) {
              const optionPrice = Number.parseInt(unitSelects[index]?.selectedOptions[0]?.dataset.price || fallbackPrice || '0', 10);
              originalTotal += optionPrice;
            }

            const discountedTotal = Math.round(originalTotal * (100 - discount) / 100);
            const math = card.querySelector('[data-tier-math]');

            if (!math) return;

            const original = math.querySelector('[data-tier-original]');
            const total = math.querySelector('[data-tier-total]');
            const savings = math.querySelector('[data-tier-savings]');

            if (!total) return;

            if (discount > 0) {
              if (original) {
                original.hidden = false;
                original.textContent = this.formatMoney(originalTotal);
              }
              total.textContent = this.formatMoney(discountedTotal);
              if (savings) {
                savings.hidden = false;
                savings.textContent = `${this.dataset.savingsLabel || 'You save'} ${this.formatMoney(originalTotal - discountedTotal)}`;
              }
            } else {
              if (original) {
                original.hidden = true;
                original.textContent = '';
              }
              total.textContent = this.formatMoney(originalTotal);
              if (savings) {
                savings.hidden = true;
                savings.textContent = '';
              }
            }
          });
        }

        formatMoney(cents) {
          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency: this.dataset.currencyCode || 'USD',
              maximumFractionDigits: 2,
            }).format((Number(cents) || 0) / 100);
          } catch (error) {
            return `${((Number(cents) || 0) / 100).toFixed(2)}`;
          }
        }

        updateNativeControls() {
          if (!this.form) {
            return;
          }

          const quantitySelector = this.form.querySelector('quantity-selector');
          const quantityInput = quantitySelector?.querySelector('[name="quantity"]');
          const buttonContent = this.form.querySelector('button[type="submit"] button-content');

          if (quantitySelector) {
            if (!quantitySelector.hasAttribute('data-bastion-volume-original-hidden')) {
              quantitySelector.dataset.bastionVolumeOriginalHidden = quantitySelector.hidden ? 'true' : 'false';
            }

            quantitySelector.hidden = quantitySelector.dataset.bastionVolumeOriginalHidden === 'true';
          }

          if (quantityInput) {
            if (!quantityInput.hasAttribute('data-bastion-volume-original-disabled')) {
              quantityInput.dataset.bastionVolumeOriginalDisabled = quantityInput.disabled ? 'true' : 'false';
            }

            quantityInput.disabled = quantityInput.dataset.bastionVolumeOriginalDisabled === 'true';
          }

          if (buttonContent) {
            if (!buttonContent.dataset.bastionVolumeOriginalLabel) {
              buttonContent.dataset.bastionVolumeOriginalLabel = buttonContent.textContent.trim();
            }

            const nextLabel = buttonContent.dataset.bastionVolumeOriginalLabel;

            if (buttonContent.textContent !== nextLabel) {
              buttonContent.textContent = nextLabel;
            }
          }
        }

        restoreNativeQuantity() {
          if (!this.form) return;

          const quantitySelector = this.form.querySelector('quantity-selector');
          const quantityInput = quantitySelector?.querySelector('[name="quantity"]');

          if (quantitySelector?.dataset.bastionVolumeOriginalHidden) {
            quantitySelector.hidden = quantitySelector.dataset.bastionVolumeOriginalHidden === 'true';
          }

          if (quantityInput?.dataset.bastionVolumeOriginalDisabled) {
            quantityInput.disabled = quantityInput.dataset.bastionVolumeOriginalDisabled === 'true';
          }
        }

        getLineItemProperties() {
          const properties = {};

          this.form.querySelectorAll('[name^="properties["]').forEach((field) => {
            if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
            if (field.value === '') return;

            const match = field.name.match(/^properties\[(.+)]$/);
            if (match) properties[match[1]] = field.value;
          });

          return properties;
        }

        buildItems() {
          const properties = this.getLineItemProperties();
          const sellingPlan = this.form.querySelector('[name="selling_plan"]')?.value;
          const items = Array.from(this.querySelectorAll('[data-volume-unit]:not([hidden]) [data-volume-variant]')).map((select) => {
            const item = { id: select.value, quantity: 1 };
            if (Object.keys(properties).length) item.properties = properties;
            if (sellingPlan) item.selling_plan = sellingPlan;
            return item;
          });

          document.querySelectorAll(`bastion-product-add-ons[form="${CSS.escape(this.form.id)}"]`).forEach((addOns) => {
            const addOnQuantity = addOns.hasAttribute('match-main-quantity') ? this.selectedQuantity : 1;

            addOns.querySelectorAll('[data-add-on-checkbox]:checked:not(:disabled)').forEach((checkbox) => {
              items.push({ id: checkbox.value, quantity: addOnQuantity });
            });
          });

          return this.mergeItems(items);
        }

        mergeItems(items) {
          const merged = new Map();

          items.forEach((item) => {
            const key = JSON.stringify({ id: item.id, selling_plan: item.selling_plan || null, properties: item.properties || {} });

            if (merged.has(key)) {
              merged.get(key).quantity += item.quantity;
            } else {
              merged.set(key, { ...item, properties: item.properties ? { ...item.properties } : undefined });
            }
          });

          return Array.from(merged.values());
        }

        async handleOfferSubmit(offerButton) {
          if (!this.isBundle) {
            return;
          }

          if (offerButton.getAttribute('aria-busy') === 'true') {
            return;
          }

          if (!this.form.checkValidity()) {
            this.form.reportValidity();
            return;
          }

          const items = this.buildItems();

          if (items.length === 0) {
            this.showError('Choose an available variant for every pen.');
            return;
          }

          offerButton.setAttribute('aria-busy', 'true');

          const sectionsToBundle = new Set();
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true,
            detail: { sections: sectionsToBundle },
          }));
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({ items, sections: Array.from(sectionsToBundle).join(',') }),
            });
            const responseJson = await response.json();

            if (!response.ok) {
              throw new Error(responseJson.description || responseJson.message || 'The offer could not be added to the cart.');
            }

            if (window.themeVariables?.settings?.cartType === 'page' || window.themeVariables?.settings?.pageType === 'cart') {
              window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
              return;
            }

            const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((cartResponse) => cartResponse.json());
            cart.sections = responseJson.sections;
            const addedItems = responseJson.items || [];

            this.form.dispatchEvent(new CustomEvent('variant:add', {
              bubbles: true,
              detail: { items: addedItems, cart },
            }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'variant:add', cart },
            }));
          } catch (error) {
            this.form.dispatchEvent(new CustomEvent('cart:error', {
              bubbles: true,
              detail: { error: error.message },
            }));
            this.showError(error.message);
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          } finally {
            offerButton.removeAttribute('aria-busy');
            document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          }
        }

        showError(message) {
          const status = this.querySelector('[data-volume-status]');
          if (status) {
            status.dataset.error = '';
            status.textContent = message;
          }
          document.dispatchEvent(new CustomEvent('toast:show', {
            detail: { message, tone: 'error' },
          }));
        }
      }
    );
  }

  if (!customElements.get('bastion-essential-product')) {
    customElements.define(
      'bastion-essential-product',
      class extends HTMLElement {
        connectedCallback() {
          this.videoPlaybackAbortController?.abort();
          this.videoPlaybackAbortController = new AbortController();
          this.videoPlaybackObserver = new MutationObserver(() => {
            this.setupVideoPlayback();
            this.setupAfterpayTheme();
          });
          this.videoPlaybackObserver.observe(this, { childList: true, subtree: true });

          this.afterpayThemeObserver?.disconnect();
          this.afterpayThemeObserver = new MutationObserver(() => this.setupAfterpayTheme());
          this.afterpayThemeObserver.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme'],
          });

          this.setupAfterpayTheme();

          customElements.whenDefined('video-media').then(() => {
            if (this.isConnected) {
              this.setupVideoPlayback();
            }
          });
        }

        disconnectedCallback() {
          this.videoPlaybackAbortController?.abort();
          this.videoPlaybackObserver?.disconnect();
          this.afterpayThemeObserver?.disconnect();
        }

        setupAfterpayTheme() {
          const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';

          this.querySelectorAll("[id*='__afterpay_on_site_messaging_'] square-placement").forEach((placement) => {
            if (!placement.dataset.bastionLightBadgeTheme) {
              placement.dataset.bastionLightBadgeTheme = placement.getAttribute('data-badge-theme') || 'mint';
            }

            const badgeTheme = isDarkMode ? 'white' : placement.dataset.bastionLightBadgeTheme;

            if (placement.getAttribute('data-badge-theme') !== badgeTheme) {
              const replacement = placement.cloneNode(false);
              replacement.setAttribute('data-badge-theme', badgeTheme);
              placement.replaceWith(replacement);
            }
          });
        }

        setupVideoPlayback() {
          this.querySelectorAll(".product-gallery__media[data-media-type='video'] video-media").forEach((videoMedia) => {
            if (videoMedia.hasAttribute('data-bastion-playback-ready') || typeof videoMedia.play !== 'function') {
              return;
            }

            const nativeVideo = videoMedia.querySelector('video');
            videoMedia.setAttribute('data-bastion-playback-ready', '');

            videoMedia.addEventListener(
              'click',
              (event) => {
                if (nativeVideo) {
                  const videoRect = nativeVideo.getBoundingClientRect();

                  if (event.clientY >= videoRect.bottom - 56) {
                    return;
                  }
                }

                if (videoMedia.hasAttribute('playing')) {
                  videoMedia.pause();
                } else {
                  if (nativeVideo?.ended) {
                    nativeVideo.currentTime = 0;
                  }

                  videoMedia.play();
                }
              },
              { signal: this.videoPlaybackAbortController.signal }
            );
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bastion-product-story-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bastion-product-story-tabs')) {
    class BastionProductStoryTabs extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[data-story-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-story-panel]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index));
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
        });

        this.addEventListener('shopify:block:select', (event) => {
          const blockId = event.detail?.blockId;
          const index = this.tabs.findIndex((tab) => tab.dataset.blockId === blockId);
          if (index >= 0) this.selectTab(index);
        });
      }

      selectTab(index, focus = false) {
        if (!this.tabs[index] || !this.panels[index]) return;

        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex].hidden = !selected;
        });

        const selectedTab = this.tabs[index];
        const scrollArea = selectedTab.closest('.bastion-product-story-tabs__tab-scroll');

        if (scrollArea) {
          const tabCenter = selectedTab.offsetLeft + selectedTab.offsetWidth / 2;
          const target = tabCenter - scrollArea.clientWidth / 2;
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          scrollArea.scrollTo({ left: target, behavior });
        }

        if (focus) selectedTab.focus();
      }

      onTabKeydown(event, index) {
        let nextIndex = null;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        if (nextIndex !== null) {
          event.preventDefault();
          this.selectTab(nextIndex, true);
        }
      }
    }

    customElements.define('bastion-product-story-tabs', BastionProductStoryTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bastion-responsive-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bastion-home-slideshow')) {
    customElements.define('bastion-home-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.status = this.querySelector('[data-status]');
        this.pauseButton = this.querySelector('[data-pause]');
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.hasAttribute('data-active')));
        this.paused = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onPrevious = () => this.show(this.index - 1, true);
        this.onNext = () => this.show(this.index + 1, true);
        this.onPause = () => this.setPaused(!this.paused);
        this.onMouseEnter = () => this.stopTimer();
        this.onMouseLeave = () => this.startTimer();
        this.onVisibilityChange = () => document.hidden ? this.stopTimer() : this.startTimer();
        this.onBlockSelect = (event) => {
          const slideIndex = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (slideIndex >= 0) {
            this.setPaused(true);
            this.show(slideIndex, false);
          }
        };

        this.querySelector('[data-previous]')?.addEventListener('click', this.onPrevious);
        this.querySelector('[data-next]')?.addEventListener('click', this.onNext);
        this.pauseButton?.addEventListener('click', this.onPause);
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true)));
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        if (this.dataset.pauseOnHover === 'true') {
          this.addEventListener('mouseenter', this.onMouseEnter);
          this.addEventListener('mouseleave', this.onMouseLeave);
        }

        this.show(this.index, false);
        this.startTimer();
      }

      disconnectedCallback() {
        this.stopTimer();
        this.querySelector('[data-previous]')?.removeEventListener('click', this.onPrevious);
        this.querySelector('[data-next]')?.removeEventListener('click', this.onNext);
        this.pauseButton?.removeEventListener('click', this.onPause);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.removeEventListener('mouseenter', this.onMouseEnter);
        this.removeEventListener('mouseleave', this.onMouseLeave);
      }

      show(requestedIndex, announce) {
        if (this.slides.length === 0) return;

        this.index = (requestedIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.toggleAttribute('data-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));

        if (announce && this.status) {
          this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
        }

        this.startTimer();
      }

      setPaused(paused) {
        this.paused = paused;
        if (this.pauseButton) {
          this.pauseButton.setAttribute('aria-pressed', String(paused));
          this.pauseButton.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        }
        paused ? this.stopTimer() : this.startTimer();
      }

      startTimer() {
        this.stopTimer();
        if (!this.hasAttribute('data-autoplay') || this.paused || this.reduceMotion || this.slides.length < 2 || document.hidden) return;
        this.timer = window.setTimeout(() => this.show(this.index + 1, false), Number(this.dataset.delay) || 6000);
      }

      stopTimer() {
        window.clearTimeout(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bastion-tabbed-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bastion-tabbed-products')) {
    class BastionTabbedProducts extends HTMLElement {
      connectedCallback() {
        if (this.initialized || this.initializationPending) return;

        if (this.classList.contains('bastion-tab-products--deferred') && 'IntersectionObserver' in window) {
          this.initializationPending = true;
          this.initializeOnInteraction = () => this.initialize();
          this.initializationObserver = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) this.initialize();
            },
            { rootMargin: '1000px 0px' }
          );
          this.initializationObserver.observe(this);
          this.addEventListener('focusin', this.initializeOnInteraction, { once: true });
          this.addEventListener('pointerenter', this.initializeOnInteraction, { once: true });
          this.addEventListener('touchstart', this.initializeOnInteraction, { once: true, passive: true });
          return;
        }

        this.initialize();
      }

      initialize() {
        if (this.initialized) return;
        this.initialized = true;
        this.initializationPending = false;
        this.initializationObserver?.disconnect();
        this.removeEventListener('focusin', this.initializeOnInteraction);
        this.removeEventListener('pointerenter', this.initializeOnInteraction);
        this.removeEventListener('touchstart', this.initializeOnInteraction);
        this.tabs = Array.from(this.querySelectorAll('[data-tab-button]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index));
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
        });

        this.panels.forEach((panel) => this.setupPanel(panel));
        this.querySelectorAll('[data-product-card]').forEach((card) => this.setupCard(card));
        this.resizeObserver = new ResizeObserver(() => {
          this.panels.forEach((panel) => this.updateArrows(panel));
        });
        this.resizeObserver.observe(this);

        this.addEventListener('shopify:block:select', (event) => {
          const panelIndex = this.panels.indexOf(event.target.closest('[data-tab-panel]'));
          if (panelIndex >= 0) this.selectTab(panelIndex);
        });
      }

      disconnectedCallback() {
        this.initializationObserver?.disconnect();
        this.resizeObserver?.disconnect();
      }

      selectTab(index, focus = false) {
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex].hidden = !selected;
        });

        const selectedTab = this.tabs[index];
        selectedTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        if (focus) selectedTab.focus();

        const selectedPanel = this.panels[index];
        if (selectedPanel) this.updateArrows(selectedPanel);
      }

      onTabKeydown(event, index) {
        let nextIndex = null;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        if (nextIndex !== null) {
          event.preventDefault();
          this.selectTab(nextIndex, true);
        }
      }

      setupPanel(panel) {
        const track = panel.querySelector('[data-product-track]');
        const previous = panel.querySelector('[data-scroll-previous]');
        const next = panel.querySelector('[data-scroll-next]');
        if (!track) return;

        const scroll = (direction) => {
          const card = track.querySelector('.bastion-tab-products__card');
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
          track.scrollBy({ left: direction * distance, behavior: 'smooth' });
        };

        previous?.addEventListener('click', () => scroll(-1));
        next?.addEventListener('click', () => scroll(1));
        track.addEventListener('scroll', () => this.updateArrows(panel), { passive: true });
        this.updateArrows(panel);
      }

      setupCard(card) {
        card.querySelectorAll('.bastion-tab-products__swatch-fieldset [type="radio"]').forEach((input) => {
          input.addEventListener('change', () => this.selectCardVariant(card, input));
        });
      }

      selectCardVariant(card, input) {
        const variantId = input.dataset.variantId;
        const state = Array.from(card.querySelectorAll('template[data-variant-state]')).find(
          (template) => template.dataset.variantState === variantId
        );

        if (!state) return;

        const variantUrl = state.dataset.variantUrl;
        const available = state.dataset.variantAvailable === 'true';
        const onSale = state.dataset.variantOnSale === 'true';

        if (variantUrl) {
          card.querySelectorAll('[data-variant-link], .bastion-tab-products__cta').forEach((link) => {
            if (link.tagName === 'A') link.href = variantUrl;
          });
        }

        const price = card.querySelector('[data-card-price]');
        if (price && state.innerHTML.trim()) price.innerHTML = state.innerHTML;

        const image = card.querySelector('.bastion-tab-products__image');
        if (image && state.dataset.imageSrc) {
          image.removeAttribute('srcset');
          image.src = state.dataset.imageSrc;
          image.alt = state.dataset.imageAlt || image.alt;
        }

        const selectedLabel = card.querySelector('[data-selected-swatch-label]');
        if (selectedLabel) selectedLabel.textContent = state.dataset.optionValue || '';

        const badge = card.querySelector('[data-card-badge]');
        if (badge) {
          badge.classList.remove('bastion-tab-products__badge--sale', 'bastion-tab-products__badge--sold-out');

          if (!available) {
            badge.hidden = false;
            badge.classList.add('bastion-tab-products__badge--sold-out');
            badge.textContent = card.dataset.soldOutLabel;
          } else if (onSale) {
            badge.hidden = false;
            badge.classList.add('bastion-tab-products__badge--sale');
            badge.textContent = card.dataset.saleLabel;
          } else {
            badge.hidden = true;
          }
        }

        const cardButton = card.querySelector('.bastion-tab-products__cta');
        const buttonContent = cardButton?.querySelector('button-content');
        const buttonLabel = available ? card.dataset.availableButtonLabel : card.dataset.soldOutButtonLabel;

        if (buttonContent && buttonLabel) {
          buttonContent.textContent = buttonLabel;
          if (buttonContent.hasAttribute('rotated-text')) buttonContent.setAttribute('rotated-text', buttonLabel);
          if (buttonContent.hasAttribute('up-text')) buttonContent.setAttribute('up-text', buttonLabel);
        }
      }

      updateArrows(panel) {
        const track = panel.querySelector('[data-product-track]');
        const previous = panel.querySelector('[data-scroll-previous]');
        const next = panel.querySelector('[data-scroll-next]');
        if (!track || !previous || !next || panel.hidden) return;

        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll - 2;
      }
    }

    customElements.define('bastion-tabbed-products', BastionTabbedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('shop-follow-lazy')) {
    class ShopFollowLazy extends HTMLElement {
      connectedCallback() {
        if (this.dataset.mounted === 'true') {
          return;
        }

        this.boundMount = this.mount.bind(this);

        if (!('IntersectionObserver' in window)) {
          this.mount();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.mount();
            }
          },
          { rootMargin: '1000px 0px' }
        );

        this.observer.observe(this);
        this.addEventListener('pointerenter', this.boundMount, { once: true });
        this.addEventListener('touchstart', this.boundMount, { once: true, passive: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      mount() {
        if (this.dataset.mounted === 'true') {
          return;
        }

        const template = this.querySelector('template');

        if (!template) {
          return;
        }

        this.dataset.mounted = 'true';
        this.observer?.disconnect();
        this.removeEventListener('pointerenter', this.boundMount);
        this.removeEventListener('touchstart', this.boundMount);

        const content = template.content.cloneNode(true);

        content.querySelectorAll('script').forEach((sourceScript) => {
          const executableScript = document.createElement('script');

          for (const attribute of sourceScript.attributes) {
            executableScript.setAttribute(attribute.name, attribute.value);
          }

          executableScript.textContent = sourceScript.textContent;
          sourceScript.replaceWith(executableScript);
        });

        this.replaceChildren(content);
      }
    }

    customElements.define('shop-follow-lazy', ShopFollowLazy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('cart-page-product-upsells')) {
    customElements.define(
      'cart-page-product-upsells',
      class extends HTMLElement {
        connectedCallback() {
          const hydrate = () => {
            const template = document.getElementById(this.dataset.templateId);
            if (!(template instanceof HTMLTemplateElement)) return;

            this.replaceChildren(template.content.cloneNode(true));
          };

          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', hydrate, { once: true });
          } else {
            hydrate();
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
